import { connect } from 'react-redux';
import {
  loadEmailReportsAction,
  createEmailReportAction,
  deleteEmailReportAction,
  updateEmailReportAction,
  loadEmailParamsAction,
  setEmailParamValueAction,
} from '@smorder/logic';

import EmailReportsDialog from './email-reports-dialog';

const mapStateToProps = state => ({
  locations: state.reports.locations,
  emailReports: state.emailReports.emailReports,
  selectedLocation: state.reports.selectedLocation,
  selectedReport: state.reports.selectedReport,
  parameters: state.emailReports.emailParams || state.reports.params,
  isLoadingParameters: !!state.loading.loaders.loadEmailParamsAction,
});

const mapDispatchToProps = dispatch => ({
  loadEmailReports: locationId => dispatch(loadEmailReportsAction.INIT({ locationId })),
  createEmailReport: emailReport => dispatch(createEmailReportAction.INIT(emailReport)),
  deleteEmailReport: emailReportId => dispatch(deleteEmailReportAction.INIT(emailReportId)),
  updateEmailReport: emailReport => dispatch(updateEmailReportAction.INIT(emailReport)),
  loadParams: dto => dispatch(loadEmailParamsAction.INIT(dto)),
  setEmailParams: emailParams => dispatch(setEmailParamValueAction(emailParams)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailReportsDialog);
